import React, { useState } from "react";
import { Types } from "./Types";
import styles from "./Components.module.css";
import { useTranslation } from "react-i18next";

const Checkbox = () => {
  const { t } = useTranslation();
  const [isDragging, setIsDragging] = useState(false);

  return (
    <div
      className={`form-group draggable ${styles["form-group"]} ${isDragging ? styles["dragging"] : ""}`}
      draggable={true}
      onDragStart={(e) => {
        e.dataTransfer.setData("add", Types.CHECKBOX);
        setIsDragging(true);
      }}
      onDragEnd={(e) => {
        setIsDragging(false);
      }}
    >
      <span className="far fa-check-square fa-3x d-block pl-2"></span>
      <label className="form-control-label">{t("Checkbox")}</label>
    </div>
  );
};

export default Checkbox;
